import React from 'react';
import { DashboardLayout } from 'src/skins/mars/components/layouts';
import { BuyMobileDataForm } from 'src/skins/mars/forms';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { MarsModal } from 'src/skins/mars/components/common';

const pageTitle = 'Buy Mobile Data';

const Wrapper = styled.div`
  section {
    margin: 1rem 0;
  }
`;

const BuyMobileData = () => {
  const history = useHistory();
  return (
    <DashboardLayout>
      <MarsModal isOpen={true} closeModal={() => history.goBack()} fullheight={true} backgroundPage="bills">
        <Wrapper>
          <h2>{pageTitle}</h2>

          <section>
            <BuyMobileDataForm />
          </section>
        </Wrapper>
      </MarsModal>
    </DashboardLayout>
  );
};

export default BuyMobileData;
